export default __webpack_public_path__ + "static/media/artfest21.ffec7e57.png";